import { Component, OnInit } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription, interval } from 'rxjs';
import { ApiService } from '../services/contratos/contratos.service';
import { AppModule } from '../app.module';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CarregaService } from '../services/carrega_file/carrega.service';
import moment from 'moment';
import { format } from 'date-fns';
import { Location } from '../../app/interfaces';

@Component({
    selector: 'app-container-flow',
    templateUrl: './container-flow.component.html',
    styleUrls: ['./container-flow.component.css'],
    standalone: false
})
export class ContainerFlowComponent implements OnInit {
  subscription: Subscription | undefined;
  items: any[] = [];
  itemsAntigo: any[] = [];
  fornecedores: any[] = [];
  posicao: any[] = [];
  sortColumn: string = '';
  sortNumber: number = 0;
  sortDirection: number = 1;
  dataLoaded = true;
  filtroDataInicio: Date = new Date();
  filtroDataTermino: Date = new Date();
  itemsFiltrados: any[] = [];
  searchText: string = '';
  items2: any[] = [ /* Seus itens aqui */];
  private searchTextSubject = new Subject<string>();
  private searchTextSubscription!: Subscription;
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlSalva: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  tableNameLocation: string = 'Fornecedores_Karrara_Transport';
  query2: string = 'veiculos_lab_Karrara'
  query3: string = 'tipos_Veiculos_Karrara';
  queryPosicao: string = 'positionLOTS';
  // query5: string = 'tipos_Veiculos_Karrara';
  queryPositionLots: string = 'positionLOTS'
  queryContainer: string = 'items_Excel_Container';
  data: any;
  editMode!: boolean[];
  informationMode!: boolean[];
  address!: string;
  DataAtual: Date = new Date();
  item: any = {
    ID: '',
    local: '',
    contato: '',
    endereco: '',
    latitude: '',
    longitude: ''
  };
  dialogOpen!: boolean;
  dialogAddViagem!: boolean;
  carriers!: any[];
  places!: any[];
  transportadora!: string[];
  locais!: any[];
  locaisName!: any[];
  datePipe: any;

  progManual: string[] = [
    'Rumo Norte EMBALAGEM'
  ];
  selectedDescription!: string;
  Transportadoras!: string;
  listaTransportadoras!: any[];
  dataInvertida: string = '';
  fornecedores1!: any[];
  fornecedores2!: any[];
  fornecedores3!: any[];
  fornecedores4!: any[];
  fornecedoresDescarga1!: any[];
  fornecedoresDescarga2!: any[];
  fornecedoresDescarga3!: any[];
  fornecedoresDescarga4!: any[];
  tipoVeiculo!: any[];
  listaVeiculo1!: any[];
  datadescarga!: string | null;
  tipoVeiculos: any;
  isLoading: boolean = true;
  posicaoCarros!: any[];
  veiculosLab: any;
  referenceDate!: string;
  itemsContainersPrev!: any[];
  faturas!: any[];
  locationsOrigem: Location =
    { local: "", latitude: 0, longitude: 0 };
  locationsDestino: Location =
    { local: "", latitude: 0, longitude: 0 };
  veiculos!: any[];

  constructor(private dynamoDBService: ApiService, public dialog: MatDialog, private http: HttpClient, private carregaService: CarregaService) {
    this.editMode = [];
    this.informationMode = [];
  }

  async ngOnInit() {
    await this.getLocais();
    await this.getVeiculosLab();
    await this.update()
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.update()
      this.isLoading = false;
    });
  }

  async update() {
    await this.getItemsFromDynamoDB();
    await this.getPositionLotsFromDynamoDB();
    await this.armazenarLatitudeEmItems();
    // await this.getItemsFaturaContainer();
    // await this.relacionarFaturasContainer();
    // await this.calcularDistancia();
    // await this.getVeiculosFromDynamoDB();
    // await this.calculoConsumo();
    this.isLoading = false;
  }

  async deleteItem(ID: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      await this.dynamoDBService.deleteItem(ID, this.urlSalva, this.queryContainer).subscribe(
        async response => {
          // setTimeout(() => {
          await this.ngOnInit();
          this.isLoading = false;
        },
        error => {
        }
      );
    }
  }

  isISODateValid(dateString: string) {
    // Tenta criar um objeto Date a partir da string
    const date = new Date(dateString);
    // Verifica se o objeto Date é um objeto de data válido e não é NaN
    return !isNaN(date.getTime());
  }

  cancel(): void {
    this.dialogOpen = false;
    this.dialogAddViagem = false;
  }

  editDialog(item: any): void {
    // console.log(item)
    // console.log(typeof item.Janela)
    // console.log(item.Janela)
    this.item = { ...item }
    // const date = new Date(item.Janela);
    // date.setHours(date.getHours() - 3);
    // const formattedDate = date.toISOString();
    // console.log(formattedDate);
    // const dataHoraString = item.Janela;
    item.dataJanela = item.Janela.slice(0, 10);
    item.horaJanela = item.Janela.slice(11, 16); // "00:00"
    this.item.ID = item.ID;
    this.item.dataJanela = item.dataJanela;
    this.item.horaJanela = item.horaJanela;
    this.item.dataFalta = item.dataFalta;
    this.item.destino = item.destino;
    this.item.destinoApos = item.destinoApos;
    this.item.fatura = item.fatura;
    this.item.idContainer = item.idContainer;
    this.item.invoiceRemarks = item.invoiceRemarks;
    this.item.itemCritico = item.itemCritico;
    this.item.Janela = item.Janela;
    this.item.lastupdate = item.lastupdate;
    this.item.linner = item.linner;
    this.item.num_NF1 = item.num_NF1;
    this.item.processo = item.processo;
    this.item.quantidadeMU = item.quantidadeMU;
    this.item.tableName = item.tableName;
    this.item.terminalAtual = item.terminalAtual;
    this.item.terminalOrigem = item.terminalOrigem;
    this.item.transportador = item.transportador;
    this.item.Plate = item.Plate;
    this.item.danificado = item.danificado;
    this.dialogOpen = true;
  }

  async salvar(item: any): Promise<void> {
    this.isLoading = true;
    this.dialogOpen = false;
    // console.log(item)
    if (item.Plate != undefined) {
      // console.log("entrou no calculo consumo")
      item = await this.calculoConsumo(item);
    }
    const dataHoraString = `${item.dataJanela}T${item.horaJanela}:00.000Z`;
    const dataHoraString2 = `${item.dataJanela}T${item.horaJanela}:00`;
    // console.log(dataHoraString)
    const dataHora = new Date(dataHoraString2);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let body = [];
    body = [{
      ...item, // Mantém as chaves existentes
      "ID": item.ID,
      "Plate": item.Plate,
      "danificado": item.danificado,
      "Janela": dataHoraString,
      "jan1": dataHora.toISOString(),
      // Adicione outros campos conforme necessário
    }];
    // console.log(body)
    await this.dynamoDBService.salvar(body, this.queryContainer, this.urlSalva).subscribe(async response => {
      // Atualiza o item no banco de dados com sucesso
      // await this.ngOnInit();
      console.log('Dados salvos com sucesso!')
      await this.update();
      this.isLoading = false;
    }, error => {
      console.log(error);
      // Lidar com o erro ao atualizar o item no banco de dados
    });
  }

  async converterStringParaData(dataString: string): Promise<String> {
    // Dividir a string em partes
    const partes = dataString.split(/[\s/:]+/);
    // Converter as partes para números
    const [dia, mes, ano, hora, minuto, segundo] = partes.map(Number);
    // Criar um objeto Date
    const data = new Date(ano, mes - 1, dia, hora, minuto, segundo);
    const newDateString = format(data, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
    return newDateString;
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getItemsFromDynamoDB(): Promise<void> {

    try {
      const lambdaEvent = {
        "tableName": "items_Excel_Container",
        "searchConditions": [
          // { "column": "Finalizada", "word": true, "negate": true },
          // { "column": "description", "word": "JSL", "negate": false },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true },
          // { "column": "ID", "word": "", "negate": true }
        ]
      };

      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = await JSON.parse(response.body);

          // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
          // try {
          //   const response: any = await new Promise(async (resolve, reject) => {
          //     (await this.dynamoDBService.getItemsVolumesAltos("items_Excel_Container", this.urlConsultaCompactada, 'All', "Janela", this.referenceDate, 30)).subscribe(
          //       (res: any) => resolve(res),
          //       (error: any) => reject(error)
          //     );
          //   });
          //   if (response.statusCode == 200) {
          //     try {
          //       // //console.log(response.body)
          //       const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            // this.items = items.filter(item => {
            //   return item.Finalizada != true
            // })
            this.items = items
            // console.log(this.items)

            this.items = items
              .filter(item => item.Finalizada != true && item.Finalizada != "true" && item.Finalizada != "True" && item.FinalizadaManual != true);

            this.items = items
              .filter(item => !item.destino.includes("PNEU"));

            this.items.forEach(item => {
              item['Total Distance'] = item.distanceTrecho2;
            })
            // console.log(this.items)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getVeiculosLab(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.query2, this.urlConsulta, '')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculosLab = items
              .map(item => ({ ...item, checked: false }));
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Filtra os itens com chave 'DataBordo' indefinida
            // console.log(this.veiculosLab)

          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getPositionLotsFromDynamoDB(): Promise<void> {
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamoDBService.getItems(this.queryPositionLots, this.urlConsulta, 'All')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.posicaoCarros = items
              .map(item => ({ ...item, checked: false }));
            // console.log(this.posicaoCarros)
            this.posicaoCarros.some(position => {
              const vin = position.VIN;
              const matchingVeic = this.veiculosLab.find((obj: { [x: string]: any; }) => obj['vincode'] == vin);
              if (matchingVeic) {
                // console.log(matchingVeic)
                // position['placa'] = matchingVeic['placa'];
                position['modelo'] = matchingVeic['modelo'];
                return false; // Retorna false para continuar iterando
              } else {
                return true; // Retorna true para sair do loop
              }
            });

            // console.log(this.posicaoCarros)
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  armazenarLatitudeEmItems() {
    //console.log("entrou em armazenarLatitudeEmItems")
    for (let i = 0; i < this.items.length; i++) {
      const Plate = this.items[i]['Plate'];
      const matchingPosicao = this.posicaoCarros.find(obj => obj['placa'] === Plate);
      // console.log(matchingPosicao)
      if (matchingPosicao) {
        this.items[i]['position'] = matchingPosicao['Latitude'] + ' , ' + matchingPosicao['Longitude'];
        this.items[i]['Latitude'] = matchingPosicao['Latitude'];
        this.items[i]['Longitude'] = matchingPosicao['Longitude'];
        this.items[i]['localizacao'] = matchingPosicao['Endereco'];
        this.items[i]['data_atualizacao'] = new Date(matchingPosicao['data_atualizacao']);
        this.items[i]['DataBordo'] = new Date(matchingPosicao['PositionDateTime']);
        // console.log(matchingPosicao)
      }
      if (this.items[i]['DataBordo'] === undefined) {
        this.items[i]['Conexao'] = false;
      } else {
        this.DataAtual = new Date();
        var outraData = new Date(this.items[i]['DataBordo']);
        // Obtém o deslocamento de fuso horário em minutos
        var offset = outraData.getTimezoneOffset();
        // Ajusta a data subtraindo o deslocamento de fuso horário em minutos
        outraData.setMinutes(outraData.getMinutes() - offset);
        // console.log(outraData)
        if (new Date(outraData.setHours(outraData.getHours() + 1)) > this.DataAtual) {
          this.items[i]['Conexao'] = true;
        } else {
          this.items[i]['Conexao'] = false;
        }
      }
    }
  }

  async completaViagem(item: any) {
    const confirmacao = window.confirm("Tem certeza que deseja finalizar esta viagem?");
    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;
      const body = [{
        ...item, // Mantém as chaves existentes
        "ID": item.ID,
        "Finalizada": true,
      }];
      //nao usa a query, ele manda a time table no item
      await this.dynamoDBService.salvar(body, this.queryContainer, this.urlSalva).subscribe(async response => {
        // Atualiza o item no banco de dados com sucesso
        await this.update();
        this.isLoading = false;
      }, error => {
        console.log(error);
        // Lidar com o erro ao atualizar o item no banco de dados
      });
    }
  }

  // async getVeiculosFromDynamoDB(): Promise<void> {
  //   try {
  //     const filtro = '';
  //     const response: any = await new Promise(async (resolve, reject) => {
  //       (await this.dynamoDBService.getItems(this.query3, this.urlConsulta, filtro)).subscribe(
  //         (res: any) => resolve(res),
  //         (error: any) => reject(error)
  //       );
  //     });

  //     if (response.statusCode === 200) {
  //       try {
  //         const items = JSON.parse(response.body);
  //         if (Array.isArray(items)) {
  //           this.veiculos = items;
  //         } else {
  //           console.error('Invalid items data:', items);
  //         }
  //       } catch (error) {
  //         console.error('Error parsing JSON:', error);
  //       }
  //     } else {
  //       console.error('Invalid response:', response);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  async getLocais(): Promise<void> {
    const filtro = '';
    (await this.dynamoDBService.getItems(this.tableNameLocation, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.locais = items;
              // console.log(this.locais)
              this.locaisName = this.locais.map(item => item.local);
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  findLocationByName(name: string, locations: any[]): Location {
    return locations['find']((location: { local: string; }) => location.local === name);
  }

  // async calcularDistancia() {
  //   // console.log(this.items)
  //   let atualLocation = { local: "", latitude: 0, longitude: 0 };
  //   let distance = [0, 0];
  //   let distance2 = [0, 0];
  //   this.items.forEach(async container => {
  //     const origemLocation = this.findLocationByName(container.terminalOrigem, this.locais);
  //     if (container.terminalAtual != "SSZ") {
  //       atualLocation = this.findLocationByName(container.terminalAtual, this.locais);
  //       if (origemLocation && atualLocation) {
  //         var origemLocationNumber = this.convertItem(origemLocation);
  //         var atualLocationNumber = this.convertItem(atualLocation);
  //         distance = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
  //       }
  //       const destino = this.findLocationByName(container.destino, this.locais);
  //       if (atualLocation && destino) {
  //         // var atualLocationNumber = this.convertItem(origemLocation);
  //         var destinoNumber = this.convertItem(destino);
  //         distance2 = await this.calcularRota([atualLocationNumber.longitude, atualLocationNumber.latitude], [destinoNumber.longitude, destinoNumber.latitude]);
  //       }
  //       distance = this.sumArrays(distance, distance2);
  //       container.distance = distance[0];
  //       console.log(distance);
  //     } else {
  //       atualLocation = this.findLocationByName(container.destino, this.locais);
  //       if (origemLocation && atualLocation) {
  //         var origemLocationNumber = this.convertItem(origemLocation);
  //         var atualLocationNumber = this.convertItem(atualLocation);
  //         // console.log(origemLocationNumber)
  //         // console.log(atualLocationNumber)
  //         distance = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
  //         container.distance = distance[0];
  //         console.log(distance);
  //       }
  //     }
  //   });
  // }

  // convertItem(item: any): any {
  //   return {
  //     ID: item.ID,
  //     latitude: parseFloat(item.latitude),  // Convertendo latitude para número
  //     local: item.local,
  //     longitude: parseFloat(item.longitude),  // Convertendo longitude para número
  //     tableName: item.tableName
  //   };
  // }

  // sumArrays(array1: number[], array2: number[]): number[] {
  //   if (array1.length !== array2.length) {
  //     throw new Error('Arrays must have the same length');
  //   }
  //   return array1.map((value, index) => value + array2[index]);
  // }

  // calculoConsumo(item: any) {
  //   // console.log(this.items)
  //   // console.log(this.veiculosLab)
  //   // this.items.forEach(container => {
  //   item['Transport Type'] = this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == item.Plate) ? this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == item.Plate).modelo : "R450 LA4x2MNA";
  //   item.emissao = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']) ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']).emissoes : 0;
  //   item.consumo = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']) ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == item['Transport Type']).consumo : 0;
  //   item.emissaoTotal = (item.distance * item.emissao) / item.consumo;
  //   // });
  //   // console.log(this.item)
  //   return item;
  // }

  convertItem(item: any): any {
    return {
      ID: item.ID,
      latitude: parseFloat(item.latitude),  // Convertendo latitude para número
      local: item.local,
      longitude: parseFloat(item.longitude),  // Convertendo longitude para número
      tableName: item.tableName
    };
  }

  async calculoConsumo(container: any): Promise<any> {
    // for (const container of items) {
      let atualLocation = { local: "", latitude: 0, longitude: 0 };
      let distance1 = [0, 0];
      let distance2 = [0, 0];
      let distanceTotal = [0, 0];
      const origemLocation = this.findLocationByName(container.terminalOrigem, this.locais);
      atualLocation = await this.findLocationByName(container.terminalAtual, this.locais);
      const destinoLocation = await this.findLocationByName(container.destino, this.locais);
      if (origemLocation && atualLocation) {
        const origemLocationNumber = this.convertItem(origemLocation);
        var atualLocationNumber = this.convertItem(atualLocation);
        distance1 = await this.calcularRota([origemLocationNumber.longitude, origemLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
        container.distanceTrecho1 = distance1[0];
      }
      if (destinoLocation && atualLocation) {
        const destinoLocationNumber = this.convertItem(destinoLocation);
        var atualLocationNumber = this.convertItem(atualLocation);
        distance2 = await this.calcularRota([destinoLocationNumber.longitude, destinoLocationNumber.latitude], [atualLocationNumber.longitude, atualLocationNumber.latitude]);
        container.distanceTrecho2 = distance2[0];
      }
      // console.log(container.idContainer)
      // console.log(container.distanceTrecho1)
      // console.log(container.distanceTrecho2)
      container['Transport Type'] = this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate)
        ? this.veiculosLab.find((veiculo: { placa: any; }) => veiculo.placa == container.Plate).modelo
        : "R450 LA4x2MNA";
      container.emissao = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
        ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).emissoes
        : 0;
      container.consumo = this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type'])
        ? this.veiculosLab.find((veiculo: { modelo: any; }) => veiculo.modelo == container['Transport Type']).consumo
        : 0;
      container.emissaoTrecho1 = (container.distanceTrecho1 * container.emissao) / container.consumo;
      container.emissaoTrecho2 = (container.distanceTrecho2 * container.emissao) / container.consumo;

      container['Total Distance'] = container.distanceTrecho1 + container.distanceTrecho2;
      container['emissaoTotal'] = container.emissaoTrecho1 + container.emissaoTrecho2;
      // console.log(container['Total Distance'])
    // }
    // console.log(items)
    return container;
  }

  // toRadians(degrees: number): number {
  //   return degrees * (Math.PI / 180);
  // }

  // haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
  //   const R = 6371; // Raio da Terra em quilômetros
  //   const dLat = this.toRadians(lat2 - lat1);
  //   const dLon = this.toRadians(lon2 - lon1);
  //   const radLat1 = this.toRadians(lat1);
  //   const radLat2 = this.toRadians(lat2);
  //   const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //     Math.cos(radLat1) * Math.cos(radLat2) *
  //     Math.sin(dLon / 2) * Math.sin(dLon / 2);
  //   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //   const distance = R * c;
  //   return distance;
  // }

  // async getRota() {
  //   this.rota = await this.calcularRota([-46.633308, -23.550520], [-43.1729, -22.9068]);
  //   console.log(this.rota);
  // }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number]> {
    try {
      // console.log(startLocation)
      // console.log(endLocation)
      const response: any = await (await this.dynamoDBService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return [0, 0];
        }
      } else {
        console.error('Invalid response:', response);
        return [0, 0];
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return [0, 0];
    }
  }

  // onStartNodeServer() {
  //   this.carregaService.startNodeServer().subscribe(() => {
  //     console.log('Servidor Node.js iniciado com sucesso!');
  //   }, (error) => {
  //     console.error('Erro ao iniciar o servidor Node.js:', error);
  //   });
  //   // this.carregaService.startNodeServer()
  // }

}
